import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilSpeedometer,
  cilCloudUpload,
  cilLibrary,
  cilChartLine,
  cilStorage,
  cilTags,
  cilCart,
  cilBell,
  cibMessenger,
} from "@coreui/icons";
import { CNavItem } from "@coreui/react";

const _nav = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/seller/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Profile Verification",
    to: "/seller/verification-list",
    icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavItem,
  //   name: "Verification Form",
  //   to: "/seller/verification-form",
  //   icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
  // },
  /*
  {
    component: CNavItem,
    name: "Upload KYC",
    to: "/seller/upload-kyc",
    icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Upload Certificates",
    to: "/seller/certificate",
    icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
  },
  */
  {
    component: CNavItem,
    name: "Create Bid",
    to: "/seller/products",
    icon: <CIcon icon={cilLibrary} customClassName="nav-icon" />,
  },

  // {
  //   component: CNavItem,
  //   name: "Metal Price",
  //   to: "/seller/metal-price",
  //   icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: "Manage Stock",
    to: "/seller/manage-stock",
    icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Seller Bids",
    to: "/seller/seller-bids",
    icon: <CIcon icon={cilTags} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "View Orders",
    to: "/seller/view-orders",
    icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Requested Bids",
    to: "/seller/requested-bids",
    icon: <CIcon icon={cilTags} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Requested Bid Orders",
    to: "/seller/requested-bid-orders",
    icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Received Offers",
    to: "/seller/received-offers",
    icon: <CIcon icon={cilTags} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Delivery Requests",
    to: "/seller/range-requested",
    icon: <CIcon icon={cilTags} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Notifications",
    to: "/seller/notifications",
    icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavItem,
  //   name: "Chat",
  //   to: "/seller/chat",
  //   icon: <CIcon icon={cibMessenger} customClassName="nav-icon" />,
  // },
];

export default _nav;
